import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
@Injectable({
    providedIn: 'root'
})
export class ConfigurationActivityService{
 constructor(private httpClient:HttpClient){}  
 
 
 getAllActivity(){
    return this.httpClient.get<any>(`${environment.activity}/LionO360/2.0/API/ActivityType`)
}

updateActivity(data:any){
    return this.httpClient.post<any>(`${environment.activity}/LionO360/2.0/API/ActivityType`,data)
} 

}
